import React from 'react'
import FooterIcons from '../footerIcon/FooterIcons';
import "./Footer.css";

const Footer = () =>{
    return(
        <footer>
            <div>
                <FooterIcons/>
                <p className="footer">&copy;2020 William Morris - Web Dev Student</p>                
            </div> 
        </footer>
    )
};
export default Footer